module.exports = "<div class=\"colorBar\"></div>\n<mat-dialog-content>\n  <h3>Czy napewno chcesz usunąć tę ofertę?</h3>\n</mat-dialog-content>\n<mat-dialog-actions>\n  <div class=\"modalActionButtons\">\n    <button mat-button [mat-dialog-close]=\"false\">Anuluj</button>\n    <button mat-button [mat-dialog-close]=\"true\" cdkFocusInitial>Usuń</button>\n  </div>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/offers/campaigns/remove-offer-dialog/remove-offer-dialog.component.html
// module id = ./src/app/modules/offers/campaigns/remove-offer-dialog/remove-offer-dialog.component.html
// module chunks = main